import {
  IItem,
  AbstractOptionSelectableTextItem,
  ComboBoxItem,
  RollItem,
  IValueContainable,
  TextItemOption,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractItemValueAccessor } from "./AbstractValueAccessor";

export class TextItemOptionValueAccessor extends AbstractValueAccessor<TextItemOption> {
  constructor(source: IItem) {
    super(TextItemOptionValueAccessor._createAccessor(source));
  }

  private static _createAccessor(source: IItem): IValueAccessible<TextItemOption> {
    if (source instanceof RollItem || source instanceof ComboBoxItem) {
      return new OptionSelectableTextItemOptionValueAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractTextItemOptionValueAccessor<T extends IItem & IValueContainable> extends AbstractItemValueAccessor<T, TextItemOption> {
  constructor(source: T) {
    super(source);
  }

  protected _set(source: T, value: TextItemOption): void {
    this.__set(source, value);
  }

  protected abstract __set(source: T, value: TextItemOption): void;
}

class OptionSelectableTextItemOptionValueAccessor extends AbstractTextItemOptionValueAccessor<AbstractOptionSelectableTextItem> {
  constructor(source: AbstractOptionSelectableTextItem) {
    super(source);
  }

  protected _validate(source: AbstractOptionSelectableTextItem): void {}

  protected _get(source: AbstractOptionSelectableTextItem): TextItemOption {
    return source.value;
  }

  protected __set(source: AbstractOptionSelectableTextItem, option: TextItemOption): void {
    source.options.forEach(o => o.isSelected = (o.text === option.text));
    source.applyOptionValue(option);
  }
}
